module.exports = __webpack_public_path__ + "img/avatar-ifcmaravilhas.20bab9b4.jpg";